import { Check, X, Clock, type LucideIcon } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import type { EventStatus } from "@/types";

const statusConfig: Record<
  EventStatus,
  { label: string; bg: string; text: string; icon?: LucideIcon }
> = {
  draft: {
    label: "Szkic",
    bg: "rgba(148, 163, 184, 0.15)",
    text: "rgb(100, 116, 139)",
  },
  pending: {
    label: "Oczekujące",
    bg: "rgba(235, 200, 51, 0.18)",
    text: "#8A6B00",
    icon: Clock,
  },
  approved: {
    label: "Zatwierdzone",
    bg: "rgba(45, 141, 87, 0.12)",
    text: "var(--pulso-semantic-success)",
    icon: Check,
  },
  rejected: {
    label: "Odrzucone",
    bg: "rgba(232, 92, 58, 0.12)",
    text: "var(--pulso-semantic-destructive)",
    icon: X,
  },
};

interface StatusBadgeProps {
  status: EventStatus;
  rejectionReason?: string | null;
}

export function StatusBadge({ status, rejectionReason }: StatusBadgeProps) {
  const { label, bg, text, icon: Icon } = statusConfig[status];
  const badge = (
    <span
      className="inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold"
      style={{ backgroundColor: bg, color: text }}
    >
      {Icon && <Icon className="h-3 w-3" strokeWidth={3} />}
      {label}
    </span>
  );

  if (status === "rejected" && rejectionReason) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{badge}</TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <p className="text-xs">{rejectionReason}</p>
        </TooltipContent>
      </Tooltip>
    );
  }

  return badge;
}
